import { FC } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconCrossEye } from '../../../../icon/IconCrossEye';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { AVATAR_SIZE, POST_GRID_CARD_FOOTER_HEIGHT } from '../../constants';
import { ReportedPostProps } from './types';

export const ReportedPost: FC<ReportedPostProps> = ({ text = 'Пост скрыт из вашей ленты' }) => {
    const t = useTranslation();

    return (
        <Box width="100%" height="100%">
            <Flex
                height={`calc(100% - ${POST_GRID_CARD_FOOTER_HEIGHT + 12}px)`}
                alignItems="center"
                justifyContent="center"
                backgroundColor="var(--placeholder)"
            >
                <IconCrossEye size={32} color="var(--control-disabled-color)" />
                <Typography
                    variant="caption"
                    color="var(--control-disabled-color)"
                    mt={1}
                    px={1}
                    textAlign="center"
                >
                    {t(text)}
                </Typography>
            </Flex>
            <Flex
                px={0.5}
                height={POST_GRID_CARD_FOOTER_HEIGHT}
                direction="row"
                width="100%"
                alignItems="center"
            >
                <Box
                    height={AVATAR_SIZE}
                    width={AVATAR_SIZE}
                    mr={1}
                    borderRadius="100%"
                    backgroundColor="var(--placeholder)"
                />
                <Box backgroundColor="var(--placeholder)" height={14} width="65%" />
            </Flex>
        </Box>
    );
};
